<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-03-21 10:28:34
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-28 18:09:59
-->
<template>
  <a-spin :spinning="appLoading">
    <div class="applay-box">
      <div>
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">申请人信息</div>
        </div>
        <!-- <div class="txt-box">
        <div class="txt">申请类型</div>
        <div class="txt-two">
          {{ resData.applyType == 0 ? "公民" : "法人/其他组织" }}
        </div>
      </div> -->
        <!-- <div class="txt-box">
        <div class="txt">姓名</div>
        <div class="txt-two">{{ resData.name }}</div>
      </div>
      <div v-if="resData.applyType == 0" class="txt-box">
        <div class="txt">证件类型</div>
        <div class="txt-two">
          {{
            resData.isApplyOpenCitizenEntity &&
            resData.isApplyOpenCitizenEntity.certificateType == 0
              ? "身份证"
              : resData.isApplyOpenCitizenEntity &&
                resData.isApplyOpenCitizenEntity.certificateType == 1
              ? "工作证"
              : resData.isApplyOpenCitizenEntity &&
                resData.isApplyOpenCitizenEntity.certificateType == 2
              ? "学生证"
              : resData.isApplyOpenCitizenEntity &&
                resData.isApplyOpenCitizenEntity.certificateType == 3
              ? "军官证"
              : "护照"
          }}
        </div>
      </div>
       <div v-if="resData.applyType == 1" class="txt-box">
        <div class="txt">类型</div>
        <div class="txt-two">
          {{
            resData.isApplyOpenOrganizationEntity &&
            resData.isApplyOpenOrganizationEntity.organizationType == 0
              ? "商业企业"
              : resData.isApplyOpenOrganizationEntity &&
                resData.isApplyOpenOrganizationEntity.organizationType == 1
              ? "科研机构"
              : resData.isApplyOpenOrganizationEntity &&
                resData.isApplyOpenOrganizationEntity.organizationType == 2
              ? "社会公益组织"
              : resData.isApplyOpenOrganizationEntity &&
                resData.isApplyOpenOrganizationEntity.organizationType == 3
              ? "法律服务机构"
              : "其他"
          }}
        </div>
      </div>
      <div  v-if="resData.applyType == 0" class="txt-box">
        <div class="txt">证件号码</div>
        <div class="txt-two">
          {{
            resData.isApplyOpenCitizenEntity &&
            resData.isApplyOpenCitizenEntity.certificateNumber
          }}
        </div>
      </div>
      <div  v-if="resData.applyType == 1" class="txt-box">
        <div style="width:165px" class="txt">统一社会信用代码</div>
        <div class="txt-two">
          {{
            resData.isApplyOpenOrganizationEntity &&
            resData.isApplyOpenOrganizationEntity.socialCreditCode
          }}
        </div>
      </div>
      <div class="txt-box">
        <div class="txt">联系电话</div>
        <div class="txt-two">
          <span v-if="resData.phone">手机：{{ resData.phone }}</span> <span v-if="resData.landlinePhone">座机：{{ resData.landlinePhone }}</span>
        </div>
      </div>
      <div class="txt-box">
        <div class="txt">电子邮箱</div>
        <div class="txt-two">{{ resData.email }}</div>
      </div>
      <div class="txt-box">
        <div class="txt">邮政编码</div>
        <div class="txt-two">{{ resData.postalCode }}</div>
      </div>
      <div class="txt-box">
        <div class="txt">通信地址</div>
        <div class="txt-two">{{ resData.contactAddress }}</div>
      </div>
      <div class="txt-box">
        <div class="txt">申请方式</div>
        <div class="txt-two">
          {{
            resData.applyWayType == 0
              ? "其他"
              : resData.applyWayType == 1
              ? "当面"
              : resData.applyWayType == 2
              ? "邮寄"
              : "传值"
          }}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">身份证明</div>
        <div class="txt-two">
             <div>
               <el-image 
                class="txt-two-img" v-for="item in accessory"
                :src="item"
                :preview-src-list="accessory">
              </el-image>
             </div>
        </div>
      </div> -->

        <el-descriptions
          class="margin-top"
          title=""
          :column="3"
          :size="size"
          border
        >
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label"> 申请类型 </template>
            {{ resData.applyType == 0 ? "公民" : "法人/其他组织" }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label"> 申请方式 </template>
            {{
              resData.applyWayType == 0
                ? "其他"
                : resData.applyWayType == 1
                ? "当面"
                : resData.applyWayType == 2
                ? "邮寄"
                : "传值"
            }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label"> 邮政编码 </template>
            {{ resData.postalCode || '—' }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label"> 姓名 </template>
            {{ resData.name || '—' }}
          </el-descriptions-item>
          <el-descriptions-item :span="2" labelStyle="width:120px">
            <template slot="label"> 联系电话 </template>
            <span v-if="resData.phone">手机：{{ resData.phone }}</span>
            <span v-if="resData.landlinePhone"
              >座机：{{ resData.landlinePhone }}</span
            >
          </el-descriptions-item>
           <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px" v-if="resData.applyType == 0">
            <template slot="label"> 证件类型 </template>
            {{
              resData.isApplyOpenCitizenEntity &&
              resData.isApplyOpenCitizenEntity.certificateType == 0
                ? "身份证"
                : resData.isApplyOpenCitizenEntity &&
                  resData.isApplyOpenCitizenEntity.certificateType == 1
                ? "工作证"
                : resData.isApplyOpenCitizenEntity &&
                  resData.isApplyOpenCitizenEntity.certificateType == 2
                ? "学生证"
                : resData.isApplyOpenCitizenEntity &&
                  resData.isApplyOpenCitizenEntity.certificateType == 3
                ? "军官证"
                : "护照"
            }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px" v-if="resData.applyType == 1">
            <template slot="label"> 类型 </template>
            {{
            resData.isApplyOpenOrganizationEntity &&
            resData.isApplyOpenOrganizationEntity.organizationType == 0
              ? "商业企业"
              : resData.isApplyOpenOrganizationEntity &&
                resData.isApplyOpenOrganizationEntity.organizationType == 1
              ? "科研机构"
              : resData.isApplyOpenOrganizationEntity &&
                resData.isApplyOpenOrganizationEntity.organizationType == 2
              ? "社会公益组织"
              : resData.isApplyOpenOrganizationEntity &&
                resData.isApplyOpenOrganizationEntity.organizationType == 3
              ? "法律服务机构"
              : "其他"
          }}
          </el-descriptions-item>
           <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px" v-if="resData.applyType == 0">
            <template slot="label"> 证件号码 </template>
             {{
                resData.isApplyOpenCitizenEntity &&
                resData.isApplyOpenCitizenEntity.certificateNumber || '—'
              }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:130px" contentStyle="width: 150px" v-if="resData.applyType == 1">
            <template slot="label"> 统一社会信用代码 </template>
             {{
            resData.isApplyOpenOrganizationEntity &&
            resData.isApplyOpenOrganizationEntity.socialCreditCode || '—'
          }}
          </el-descriptions-item>
           <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label"> 电子邮箱 </template>
             {{ resData.email || '—' }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" :span="3">
            <template slot="label"> 通信地址  </template>
            {{ resData.contactAddress || '—' }}
          </el-descriptions-item>
           <el-descriptions-item labelStyle="width:120px">
            <template slot="label"> 身份证明  </template>
            <div>
               <el-image 
                class="txt-two-img" v-for="item in accessory"
                :src="item"
                :preview-src-list="accessory">
              </el-image>
             </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin-top: 10px">
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">所需信息情况</div>
        </div>
        <!-- <div class="txt-box">
          <div class="txt">受理机关</div>
          <div class="txt-two">{{ resData.disposeOffice }}</div>
        </div>
        <div class="txt-box">
          <div class="txt">特征描述</div>
          <div class="txt-two">{{ resData.description }}</div>
        </div>
        <div class="txt-box">
          <div class="txt">获取方式</div>
          <div class="txt-two">
            {{
              resData.getWayType == 0
                ? "当面领取"
                : resData.getWayType == 1
                ? "电子邮寄"
                : resData.getWayType == 2
                ? "邮寄"
                : resData.getWayType == 3
                ? "传值"
                : "阅读、抄录"
            }}
          </div>
        </div>
        <div class="txt-box">
          <div class="txt">载体形式</div>
          <div class="txt-two">
            {{ resData.carrierFormatType == 0 ? "纸质文本" : "数据电文" }}
          </div>
        </div>
        <div class="txt-box">
          <div class="txt">其他说明</div>
          <div class="txt-two">{{ resData.otherConditions }}</div>
        </div> -->
         <el-descriptions class="margin-top" :column="3" :size="size" border>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label">
              受理机关
            </template>
            {{ resData.disposeOffice || '—' }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label">
              获取方式
            </template>
            {{
              resData.getWayType == 0
                ? "当面领取"
                : resData.getWayType == 1
                ? "电子邮寄"
                : resData.getWayType == 2
                ? "邮寄"
                : resData.getWayType == 3
                ? "传值"
                : "阅读、抄录"
            }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label">
              载体形式
            </template>
            {{ resData.carrierFormatType == 0 ? "纸质文本" : "数据电文" }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" :span="3">
            <template slot="label">
              特征描述
            </template>
            {{ resData.description || '—' }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" :span="3">
            <template slot="label">
              其他说明
            </template>
            {{ resData.otherConditions || '—' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin-top: 10px">
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">当前状态</div>
        </div>
        <!-- <div class="txt-box">
          <div class="txt">办理状态</div>
          <div class="txt-two">
            {{
              resData.isApplyOpenLogEntity &&
              resData.isApplyOpenLogEntity.status == 0
                ? "待受理"
                : resData.isApplyOpenLogEntity &&
                  resData.isApplyOpenLogEntity.status == 1
                ? "办理中"
                : "已办结"
            }}
          </div>
        </div>
        <div class="txt-box">
          <div class="txt">办理单位</div>
          <div class="txt-two">
            {{
              resData.isApplyOpenLogEntity &&
              resData.isApplyOpenLogEntity.handlingUnit
            }}
          </div>
        </div>
        <div class="txt-box">
          <div class="txt">办理时间</div>
          <div class="txt-two">
            {{
              resData.isApplyOpenLogEntity &&
              resData.isApplyOpenLogEntity.operationTime
            }}
          </div>
        </div>
        <div class="txt-box">
          <div class="txt">备注</div>
          <div class="txt-two">
            {{
              resData.isApplyOpenLogEntity &&
              resData.isApplyOpenLogEntity.remark
            }}
          </div>
        </div> -->
        <el-descriptions class="margin-top"  :column="3" :size="size" border>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label">
              办理状态
            </template>
             {{
              resData.isApplyOpenLogEntity &&
              resData.isApplyOpenLogEntity.status == 0
                ? "待受理"
                : resData.isApplyOpenLogEntity &&
                  resData.isApplyOpenLogEntity.status == 1
                ? "办理中"
                : "已办结"
            }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label">
              办理单位
            </template>
             {{
              resData.isApplyOpenLogEntity &&
              resData.isApplyOpenLogEntity.handlingUnit || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px" contentStyle="width: 150px">
            <template slot="label">
              办理时间
            </template>
             {{
              resData.isApplyOpenLogEntity &&
              resData.isApplyOpenLogEntity.operationTime || '—'
            }}
          </el-descriptions-item>
          <el-descriptions-item labelStyle="width:120px">
            <template slot="label">
              备注
            </template>
             {{
              resData.isApplyOpenLogEntity &&
              resData.isApplyOpenLogEntity.remark || '—'
            }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { deilsData } from "../index";
export default {
  data() {
    return {
      resData: {},
      accessory: [],
      appLoading: false,
      size:'medium',
    };
  },
  props: ["itemData", "isShow"],
  methods: {
    getDeilds() {
      this.appLoading = true;
      deilsData({
        id: this.itemData.id,
      }).then((res) => {
        this.resData = res.data;
        let urls = this.resData && this.resData.accessory && JSON.parse(this.resData.accessory) || [];
        let paths = [];
        for (let index = 0; index < urls.length; index++) {
          const element = urls[index].url;
          paths.push(this.imgIp + element);
        }
        this.accessory = paths;
        this.appLoading = false;
      });
    },
  },
  mounted() {
    this.getDeilds();
  },
  watch: {
    isShow(val) {
      if (val) {
        this.getDeilds();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.applay-box {
  padding: 24px;
  padding-bottom: 20px;
  padding-top: 0px;
  padding-bottom: 100px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  width: 80px;
}
.txt-two {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  width: 100%;
}
.txt-box {
  margin-bottom: 20px;
  display: flex;
}
.txt-two-img {
  width: 90px;
  height: 90px;
  margin-right: 14px;
  background: #f6f6f6;
  /deep/ .el-image__inner {
    object-fit: contain;
  }
}
/deep/ .el-descriptions--medium.is-bordered .el-descriptions-item__cell{
  padding:8px;
  &:first-child{
    width: 120px;
  }
}
.label-box{
  width: 300px;
}
</style>